<template>
  <div class="system-page-wrapper">
    <div v-if="!hasToken && externalMessage" class="info-message">
      <div class="info-message__wrapper">
        <span class="icon-info"></span>
        <div class="info-message__content" v-html="externalMessage"></div>
      </div>
    </div>
    <div class="system-page-list">
      <strong class="system-page-list__title">{{ computedTitle }}</strong>
      <div v-for="item in systemPageListWithoutDownload" :key="item.nodeId || item.id">
        <b class="system-page-list__subtitle" v-if="itemSubtitleNeeded">
          {{ item.external?.title || '' }}
        </b>
        <div class="system-page-list__inner">
          <SystemPageItem
            v-for="systemPageItem in item.nodes"
            :key="systemPageItem.nodeId || systemPageItem.id"
            :title="setProperFieldExternalFirst(systemPageItem, 'title')"
            :longDescr="setProperFieldInternalFirst(systemPageItem, 'longDescr')"
            :resources="systemPageItem.resources"
            :link="`${mainCategories.products}/${item.nodeId}/${systemPageItem.nodeId}/`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { setProperFieldExternalFirst, setProperFieldInternalFirst } from '@/utils/fieldGetters';
  import { useMainStore } from '@/stores/main';
  interface SystemPageNode {
    productBlockType?: string;
    nodeId?: string | number;
    id?: string | number;
    resources?: any[];
    external?: {
      title?: string;
      longDescr?: string;
      [key: string]: any;
    };
    internal?: {
      title?: string;
      longDescr?: string;
      [key: string]: any;
    };
    [key: string]: any;
  }

  interface SystemPageItem {
    nodeId?: string | number;
    id?: string | number;
    resources?: any[];
    external?: {
      title?: string;
      [key: string]: any;
    };
    internal?: {
      title?: string;
      [key: string]: any;
    };
    title?: string;
    nodes?: SystemPageNode[];
    [key: string]: any;
  }

  const props = defineProps<{
    systemPageList?: SystemPageItem[];
    systemPageListTitle?: string;
    itemSubtitleNeeded?: boolean;
  }>();

  const mainStore = useMainStore();
  const mainCategories = computed(() => mainStore.mainCategories || {});
  const hasToken = computed(() => mainStore.hasToken);
  const externalMessage = computed(() => mainStore.langJson[mainStore.lang]?.externalMessage || '');
  const computedTitle = computed(() => {
    if (props.systemPageListTitle) return props.systemPageListTitle;
    const first = props.systemPageList && props.systemPageList.length > 0 ? props.systemPageList[0] : null;
    if (!first) return '';
    return first?.external?.title ?? first?.internal?.title ?? first?.title ?? '';
  });
  const systemPageListWithoutDownload = computed(() => {
    if (!props.systemPageList) return [];
    const newArr: SystemPageItem[] = [];
    for (let index = 0; index < props.systemPageList.length; index++) {
      const item = { ...props.systemPageList[index] };
      const systemPageItems = (item.nodes || []).filter((i) => i.productBlockType != 'DownloadOverview');
      item.nodes = systemPageItems;
      newArr.push(item);
    }
    return newArr;
  });
</script>
